import { AlertProps } from "react-bootstrap";
import { ITestableComponentProps } from "../../shared/types/testing.types";

export interface IGenericAlertProps
  extends ITestableComponentProps,
    AlertProps {
  message?: string;
  onClose?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export interface IAlertListProps extends ITestableComponentProps {
  className?: string;
}

export const DefaultGenericAlertProps = {
  message: "",
  enabletestid: false,
  testid: "location-alert",
};
